import { Link } from "react-router";
import { ReactSVG } from "react-svg";

import logo from "../assets/svg/logo.svg";
import star from "../assets/svg/star.svg";

const Footer = () => {
	return (
		<footer className="relative flex w-full flex-col items-center justify-center gap-6 overflow-hidden px-8 pt-20 pb-20 text-center text-sm text-white md:pt-35">
			<ReactSVG src={logo} className="[&_svg]:h-auto [&_svg]:w-60 [&_svg]:md:w-50" />
			<p>
				Sede Legale: San Giorgio di Nogaro (UD) - Via&nbsp;Enrico&nbsp;Fermi&nbsp;42
				<br />
				P. IVA 03116200308
			</p>
			<div className="flex flex-col gap-2 md:flex-row">
				<Link to="/privacy" target="_blank" rel="noopener noreferrer" className="cursor-pointer uppercase underline">
					Privacy Policy
				</Link>
				<span className="hidden md:block">|</span>
				<a href="/Procedura-whisteblowing-2026.pdf" target="_blank" className="cursor-pointer uppercase underline">
					Procedura Whistleblowing
				</a>
				<span className="hidden md:block">|</span>
				<a
					href="https://royalunibrew.whistleblowernetwork.net/?lang=it"
					target="_blank"
					className="cursor-pointer uppercase underline">
					Whistleblower
				</a>
				<span className="hidden md:block">|</span>
				<a href="/MOG-2026.pdf" target="_blank" className="cursor-pointer uppercase underline">
					Corporate Governance
				</a>
			</div>
			<div className="absolute right-0 bottom-0 hidden w-3/10 max-w-150 translate-x-4/10 translate-y-4/10 md:flex">
				<ReactSVG src={star} className="[&_svg]:fill-red [&_svg]:h-auto [&_svg]:w-full" />
			</div>
		</footer>
	);
};

export default Footer;
